import { IAddress } from "common/types";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useDeleteAddressMutation } from "client/accounts/hooks";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import AddressDrawerFrom from "../forms/AddressDrawerForm";

const noop = () => undefined;

export type AddressUpdateDrawerProps = {
  address: IAddress;
  onSuccess?: (address: IAddress) => void;
};

const AddressUpdateDrawer = ({ address, onSuccess = noop }: AddressUpdateDrawerProps) => {
  const { close } = useCurrentDrawer();

  // TODO: this multi-step process should really be one web-request to reduce edge cases on errors
  // most likely we want to surface an endpoint to do this special update or "replace" operation.
  // https://app.shortcut.com/vetcove/story/40167/support-client-address-updates
  const {
    mutate: deleteAddress,
    isLoading: isDeleteLoading,
    isSuccess: isDeleteSuccess,
  } = useDeleteAddressMutation(address.id, {
    onSuccess: close,
  });

  const handleSuccess = (newAddress: IAddress) => {
    onSuccess(newAddress);
    deleteAddress();
  };

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Update address" onClose={close} />
      <AddressDrawerFrom
        onSuccess={handleSuccess}
        isLoading={isDeleteLoading || isDeleteSuccess}
        isPrimary={true}
        initialValues={{
          address_one: address.address_one,
          address_two: address.address_two ?? "",
          city: address.city,
          state: address.state,
          zipcode: address.zipcode,
        }}
        submitText="Update address"
      />
    </DrawerLayout>
  );
};

export default AddressUpdateDrawer;
